import {Component} from "react";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import {Link, withRouter} from 'react-router-dom'
import React from "react";
import {Card, Col, Row, List} from "antd";
import moment from "moment";
import _ from "lodash";
import { isEnterpriseUser } from "../../utils/plan-utils";

export class DashboardMyPlan extends Component {
  render() {
    const {
      contractedUsers,
      contractedSpace,
      client,
      intl,
      newColor,
    } = this.props;

    const initDate = !_.isNil(client.billing) ? moment(client.billing).format('DD/MM/YYYY') : "-";
    const dueDate =  !_.isNil(client.billing) ? moment(client.billing).add(1, 'months').format('DD/MM/YYYY') : "-";

    const data = [
      {title: intl.formatMessage({id: 'contracted_users'}), detail: contractedUsers},
      {title: intl.formatMessage({id: 'contracted_space'}), detail: `${contractedSpace}`},
      {title: intl.formatMessage({id: 'billing_date'}), detail: dueDate},
      {title: intl.formatMessage({id: 'active_since'}), detail: initDate}
    ];

    return (
      <React.Fragment>
        <Card title={<p onClick={()=>this.props.history.push('/home/plan-detail')}>{intl.formatMessage({id: 'my_plan'})}</p>} hoverable className="dashboard-my-plan">
          <List
            style={{margin: "50px 0px"}}
            dataSource={data}
            renderItem={(item) => (
              <List.Item style={{padding: "3px 0px", borderBottom: 0}}>
                <div className="container">
                  <Row gutter={16}>
                    <Col span={17} style={{textAlign: "left"}}>
                      <span className="circle"/> <b>{item.title}:</b>
                    </Col>
                    <Col span={7} style={{textAlign: "left", color: '#7e7e7e'}}>
                      {item.detail}
                    </Col>
                  </Row>
                </div>
              </List.Item>
            )}
          />
          <p></p>
          {!isEnterpriseUser(client) && <Link to='/home/plan-detail'>
            <button className="ant-btn ant-btn-primary" style={{backgroundColor: newColor, borderColor: newColor}}  >
              {intl.formatMessage({id: 'modify_plan'})}
            </button>
          </Link>}
        </Card>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
  client: state.client.data,
});

export default injectIntl(withRouter(connect(mapStateToProps, {})(DashboardMyPlan)))
